'use strict';

function CancelDialog() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [Dialog, _Routes];

  this.cancelUrl = '';
  this.cancelCallback = null;

  this.init = function () {
    this._super();
    this.cancelUrl = this.cancelUrl || this.paths.account.dashboard;
    this.$node = $(this.node);
    this.$node.find('.dialog-prompt__confirm').on('click.confirm', this._confirmWarning.bind(this));
    this.$node.find('.dialog-prompt__cancel').on('click.cancel', this._hideWarning.bind(this));
  };

  this.initAllReady = function () {
    this._super();
    this.history = new History();
  };

  this.showWarning = function (event) {
    event.preventDefault();
    event.stopPropagation();
    this.show();
  };

  this._hideWarning = function () {
    this.hide();
  };

  this._confirmWarning = function () {
    this._hideWarning();
    if (this.cancelCallback) {
      this.cancelCallback();
    }
    this.history.goToUrl(this.cancelUrl);
  };

  this.destroy = function () {
    this._super();
  };
}